import { render, staticRenderFns } from "./setRemoteAssistance.vue?vue&type=template&id=3ed2c617&scoped=true&"
import script from "./setRemoteAssistance.vue?vue&type=script&lang=js&"
export * from "./setRemoteAssistance.vue?vue&type=script&lang=js&"
import style0 from "./setRemoteAssistance.vue?vue&type=style&index=0&id=3ed2c617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed2c617",
  null
  
)

component.options.__file = "setRemoteAssistance.vue"
export default component.exports